export const WaveMark = ({ className = "" }) => (
  <svg viewBox="0 0 120 60" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M4 30c14 0 14-14 28-14s14 14 28 14 14-14 28-14 14 14 28 14" opacity="0.35" />
    <path d="M4 40c14 0 14-14 28-14s14 14 28 14 14-14 28-14 14 14 28 14" />
    <path d="M4 50c14 0 14-14 28-14s14 14 28 14 14-14 28-14 14 14 28 14" opacity="0.55" />
  </svg>
);

export const BrowIllu = ({ className = "" }) => (
  <svg viewBox="0 0 220 140" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M18 62 Q110 6 202 58" />
    <path d="M30 68 Q110 20 190 64" opacity="0.35" />
    <path d="M52 104 Q110 78 168 104" />
    <path d="M52 104 Q110 126 168 104" />
    <circle cx="110" cy="102" r="13" />
    <circle cx="110" cy="102" r="5" fill="currentColor" stroke="none" />
    <path d="M60 96 l-8 -8 M80 88 l-5 -10 M140 88 l5 -10 M160 96 l8 -8" opacity="0.6" />
  </svg>
);

export const LipsIllu = ({ className = "" }) => (
  <svg viewBox="0 0 220 140" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M20 70 Q60 34 96 56 Q110 64 124 56 Q160 34 200 70" />
    <path d="M20 70 Q110 96 200 70" opacity="0.5" />
    <path d="M20 70 Q110 128 200 70" />
    <path d="M60 88 Q110 104 160 88" opacity="0.3" />
  </svg>
);

export const NailIllu = ({ className = "" }) => (
  <svg viewBox="0 0 220 140" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M50 120 L50 52 Q50 26 70 26 Q90 26 90 52 L90 120" />
    <path d="M58 44 Q70 34 82 44" opacity="0.5" />
    <path d="M110 120 L110 40 Q110 16 130 16 Q150 16 150 40 L150 120" />
    <path d="M118 32 Q130 24 142 32" opacity="0.5" />
    <path d="M168 120 L168 58 Q168 36 186 36 Q204 36 204 58" transform="translate(-14 0)" opacity="0.85" />
  </svg>
);

export const LashIllu = ({ className = "" }) => (
  <svg viewBox="0 0 220 140" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M30 80 Q110 118 190 80" />
    <path d="M48 86 l-10 12 M72 95 l-7 14 M98 100 l-3 15 M124 100 l3 15 M150 94 l7 14 M172 86 l10 12" />
    <path d="M30 62 Q110 30 190 62" opacity="0.35" />
  </svg>
);

export const StudioIllu = ({ className = "" }) => (
  <svg viewBox="0 0 220 140" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" className={className} aria-hidden="true">
    <rect x="30" y="20" width="160" height="106" />
    <path d="M95 126 L95 84 Q95 64 110 64 Q125 64 125 84 L125 126" />
    <rect x="46" y="40" width="26" height="30" />
    <rect x="148" y="40" width="26" height="30" />
    <path d="M46 55 h26 M59 40 v30 M148 55 h26 M161 40 v30" opacity="0.5" />
    <path d="M30 20 L110 4 L190 20" />
    <circle cx="110" cy="46" r="8" opacity="0.6" />
  </svg>
);

export const LaurelIllu = ({ className = "" }) => (
  <svg viewBox="0 0 220 140" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M60 122 Q30 90 44 44" />
    <path d="M160 122 Q190 90 176 44" />
    <path d="M52 100 q-16 -2 -22 10 M47 80 q-15 -6 -13 -20 M50 60 q-10 -12 -2 -24" />
    <path d="M168 100 q16 -2 22 10 M173 80 q15 -6 13 -20 M170 60 q10 -12 2 -24" />
    <path d="M85 108 Q110 92 135 108" opacity="0.8" />
    <path d="M92 108 Q110 118 128 108" opacity="0.4" />
    <circle cx="110" cy="52" r="18" opacity="0.6" />
    <path d="M102 52 l6 6 l12 -12" />
  </svg>
);

export const MacroEyeIllu = ({ className = "" }) => (
  <svg viewBox="0 0 400 240" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M20 84 Q200 8 380 78" />
    <path d="M46 94 Q200 30 354 90" opacity="0.35" />
    <path d="M90 172 Q200 118 310 172" />
    <path d="M90 172 Q200 216 310 172" />
    <circle cx="200" cy="166" r="26" />
    <circle cx="200" cy="166" r="10" fill="currentColor" stroke="none" />
    <path d="M110 158 l-16 -12 M142 144 l-10 -16 M258 144 l10 -16 M290 158 l16 -12" opacity="0.6" />
    <path d="M200 40 v-14 M160 46 l-6 -14 M240 46 l6 -14" opacity="0.4" />
  </svg>
);

export const MacroLipsIllu = ({ className = "" }) => (
  <svg viewBox="0 0 400 240" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" className={className} aria-hidden="true">
    <path d="M30 120 Q100 58 176 96 Q200 110 224 96 Q300 58 370 120" />
    <path d="M30 120 Q200 168 370 120" opacity="0.5" />
    <path d="M30 120 Q200 226 370 120" />
    <path d="M100 152 Q200 184 300 152" opacity="0.3" />
    <path d="M140 176 Q200 194 260 176" opacity="0.2" />
  </svg>
);
